<div class="p-4">
  <div class="d-flex align-items-center justify-content-between mb-3">
    <div class="card-sub-heading">
      Are you sure to update the appointment {{props?.item?.status}} status?

    </div>
    <button mat-icon-button [disabled]="isLoading" [attr.aria-disabled]="isLoading" (click)="dialogRef.close()" type="button">
      <img src="assets/images/icons/grey_cross_icon.png" alt="close icon" />
    </button>
  </div>
  <form [formGroup]="form" (ngSubmit)="formSubmit()">
    <div class="row py-2">
      <div class="col-md-12">

        <mat-checkbox class="example-margin bold mb-3" (change)="onCheckChange($event)" formControlName="NotifyUsers">
          Notify Users
        </mat-checkbox>

        <div class="row p-2" *ngIf="form.value.NotifyUsers">
          <div class="col-md-12">
            <div class="d-flex row">
              <ng-container formArrayName="NotifyUsersBy">
                <ng-container *ngFor="let item of notifyByArray.controls; let i = index">
                  <ng-container [formGroupName]="i">
                    <div class="col-md-4">
                      <mat-checkbox [value]="item.value.id" formControlName="isChecked" [disabled]="item.value.disable">
                        {{ item.value.value }}
                      </mat-checkbox>
                    </div>
                  </ng-container>
                </ng-container>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row mb-2">
      <!-- working on other input box start -->
      <div class="col-md-12 mb-3">
        <div class="form-group">
          <label class="small white-space pb-1">Practitioner Name</label> <span class="text-danger" *ngIf="isScheduledStatus">*</span>
          <input type="text" class="form-control" placeholder="Enter Practitioner Name"
            formControlName="practitioner_name" />
          <mat-error class="ml-3" *ngIf="
              form.get('practitioner_name')?.touched &&
              form.get('practitioner_name')?.hasError('required')
            ">
            Practitioner name is required
          </mat-error>
        </div>
      </div>


      <div class="col-md-6 mb-3">
        <div class="form-group">
          <label class="small white-space pb-1">Appointment date for book now</label> <span class="text-danger" *ngIf="isScheduledStatus">*</span>
          <div class="position-relative">
            <input matInput [matDatepicker]="appointmentPicker" [min]="getCurrentDate()" readonly
              (click)="appointmentPicker.open()" class="form-control" placeholder="Appointment Date"
              formControlName="appointment_datetime" (dateChange)="
                onDateChange($event, 'appointmentDate')
              " />
            <mat-datepicker-toggle matSuffix [for]="appointmentPicker" class="date-icon"></mat-datepicker-toggle>
            <mat-datepicker #appointmentPicker></mat-datepicker>
          </div>
          <mat-error class="ml-3" *ngIf="
              form.get('appointment_datetime')?.touched &&
                  form
                  .get('appointment_datetime')?.hasError('required')
              ">
            Appointment date is required
          </mat-error>
        </div>
      </div>
      <div class="col-md-6 mb-3">
        <label class="small white-space pb-1">Appointment time for book now</label><span class="text-danger" *ngIf="isScheduledStatus">*</span>
        <div class="position-timepicker">
          <input class="time-input form-control" placeholder="Appointment Time" [ngxMatTimepicker]="picker"
            formControlName="PreferredTime" />
          <span class="material-icons" (click)="picker.open()">
            watch_later
          </span>
        </div>
        <mat-error class="ml-3" *ngIf="
                form.get('PreferredTime')?.touched &&
                form.get('PreferredTime')?.hasError('required')
              ">
          Appointment time is required
        </mat-error>

        <ngx-mat-timepicker #picker></ngx-mat-timepicker>
      </div>

      <div class="col-md-12 mb-3">
        <div class="form-group">
          <label class="small white-space pb-1">Appointment Platform</label><span class="text-danger" *ngIf="isScheduledStatus">*</span>
          <mat-form-field>
            <mat-select class="form-control" placeholder="Select appointment platform"
              formControlName="appointment_platform_id">
              <mat-option *ngFor="let item of appointmentsPlateform" [value]="item.id">
                {{ item?.name }}
              </mat-option>
              <div class="add_optionBg">
                <mat-option (click)="openAddAppointementModal()">
                  <div class="d-flex align-items-center text-success f-semibold justify-content-center ">
                    <span _ngcontent-qhx-c296="" class="material-icons me-2"> add </span>Add Appointment Platform
                  </div>
                </mat-option>
              </div>
            </mat-select>
          </mat-form-field>
          <mat-error class="ml-3" *ngIf="
              form.get('appointment_platform_id')
                ?.touched &&
              form
                .get('appointment_platform_id')
                ?.hasError('required')
            ">
            Appointment paltform is required
          </mat-error>
        </div>
      </div>

      <div class="col-md-12 mb-3" *ngIf="isScheduledStatus">
        <div class="form-group">
          <label class="small white-space pb-1">Patient Group</label>
          <mat-form-field>
            <mat-select class="form-control" placeholder="Select Patient Group" formControlName="patient_group_id">
              <mat-option *ngFor="let item of patientGroupList" [value]="item.id">
                {{ item?.name }}
              </mat-option>
              <div class="add_optionBg">
                <mat-option (click)="openAddPatientGroupModal()">
                  <div class="d-flex align-items-center text-success f-semibold justify-content-center ">
                    <span _ngcontent-qhx-c296="" class="material-icons me-2"> add </span>Add Patient Group
                  </div>
                </mat-option>
              </div>
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <div class="col-md-12 mb-3" *ngIf="isVideoSelected">
        <div class="form-group">
          <label class="small white-space pb-1">Appointment Video Link</label>
          <input type="text" class="form-control" placeholder="Add video link"
            formControlName="appointment_video_link" />
        </div>
      </div>
    </div>

    <div class="row py-2" *ngIf="isCustomMessageVisible() && this.form.value.NotifyUsers">
      <div class="col-md-12">
        <mat-checkbox class="example-margin" formControlName="custom_message" (change)="onCheckMessage($event)">Custom
          Message</mat-checkbox>
      </div>
    </div>
    <div class="row" *ngIf="this.form.value.custom_message">
      <div class="col-md-12">
        <div class="form-group">
          <textarea class="form-control" formControlName="message" placeholder="Custom message enter here..."
            rows="3"></textarea>
          <mat-error class="ml-3" *ngIf="
              form.controls['message'].touched &&
              form.controls['message'].hasError('required')
            ">
            Message is required
          </mat-error>
        </div>
      </div>
    </div>

    <div class="row mt-4">
      <div class="col-md-12 d-flex align-items-end justify-content-end">
        <button class="custom-btn" [disabled]="isLoading" (click)="dialogRef.close()" type="button">
          Cancel
        </button>
        <button class="custom-btn" [disabled]="isLoading" type="submit">
          Confirm
          <span class="whiteLoader" *ngIf="isLoading"></span>
        </button>
      </div>
    </div>
  </form>
</div>
